import { takeLatest } from 'redux-saga/effects';
import { GET_COPY_MODAL_CONTEXT_DATA } from './actions';
import { getCopyModalContextDataIfNeeded } from './sagas';

function* CopyModalContextDataSaga() {
  yield takeLatest(GET_COPY_MODAL_CONTEXT_DATA, getCopyModalContextDataIfNeeded);
}

export default [CopyModalContextDataSaga];